import UserGeneratedImageForm from "./Content/UserGeneratedImage/UserGeneratedImage.Form";

UserGeneratedImageForm.init();
